import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UtensilsCrossed, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-secondary/40 px-5">
      <form onSubmit={submit} data-testid="login-form" className="w-full max-w-sm rounded-3xl border border-border bg-card p-7">
        <div className="flex items-center gap-2 mb-6">
          <span className="grid place-items-center w-9 h-9 rounded-full bg-primary text-primary-foreground">
            <UtensilsCrossed className="w-4 h-4" />
          </span>
          <span className="font-serif text-2xl text-primary">Admin Login</span>
        </div>
        <label className="text-sm font-medium">Email</label>
        <input
          data-testid="login-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 mb-4 w-full h-12 rounded-xl border border-border bg-background px-4 outline-none focus:border-primary"
          required
        />
        <label className="text-sm font-medium">Password</label>
        <input
          data-testid="login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 mb-4 w-full h-12 rounded-xl border border-border bg-background px-4 outline-none focus:border-primary"
          required
        />
        {error && <p data-testid="login-error" className="text-sm text-destructive mb-3">{error}</p>}
        <button
          data-testid="login-submit"
          type="submit"
          disabled={loading}
          className="w-full h-12 rounded-full bg-primary text-primary-foreground font-medium grid place-items-center disabled:opacity-60"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
